import { render, staticRenderFns } from "./pill.vue?vue&type=template&id=17acf44d&"
import script from "./pill.vue?vue&type=script&lang=js&"
export * from "./pill.vue?vue&type=script&lang=js&"
import style0 from "./pill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports